import { PdvService } from './../pdv/pdv.service';
import { WebSiteUsersService } from '../webSiteUsers/webSiteUsers.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';
@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
    constructor(
        private webSiteUsersService: WebSiteUsersService,
        private pdvService:PdvService
    ) {
    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('token');
        const idPdv =this.pdvService.idPdv;
        if (token) {
            req = req.clone({ setHeaders: { token: `${token}` } });
        }
        req = req.clone({ setHeaders: { pdv: `${idPdv}` } });
        return next.handle(req).catch(
            (err: any) => {
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401) {
                        localStorage.removeItem('token');
                        this.webSiteUsersService.listener.next(false);
                        // this.router.navigate(['/']);
                    }
                }
                return Observable.throw(err);
            });
    }
}


// WEBPACK FOOTER //
// ./src/providers/AddHeaderInterceptor/AddHeaderInterceptor.ts